<template>
  <div class="create-profile-container">
    <v-card elevation="0" class="px-4" >
      <div class="d-flex align-center mt-6 mb-4" style="max-width: 80%; margin: 0 auto;">
        <router-link to="/app/management/profiles" class="text-decoration-none">
          <h2 class="mr-4 breadcrumb-link"
            style="font-weight: 400; color: #203a75; font-size: 1.5rem; background-color: #f5f5f5; padding: 8px 20px; border-radius: 6px; cursor: pointer;">
            Unidades de Negócio
          </h2>
        </router-link>
        <v-icon color="#203a75" class="mx-2">mdi-chevron-right</v-icon>
        <span style="font-weight: 400; color: #203a75; font-size: 1.5rem;">
          Adicionar novo perfil
        </span>
      </div>
      
      <v-card outlined class="pa-4" style="max-width: 80%; margin: 0 auto;">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="pa-4"
        >
          <v-row class="mb-6">
            <v-col cols="12" md="2">
              <ImageUploadWithCrop
                v-model="form.logoBase64"
                label="Logo do Veículo"
                :max-size-m-b="5"
                @file-selected="handleLogoSelected"
                @image-removed="handleLogoRemoved"
              />
            </v-col>
          </v-row>

          <p class="text-left mb-1 font-weight-bold grey--text lighten-2">
            DADOS DO VEÍCULO
          </p>
          <v-divider class="mb-4"></v-divider>

          <v-row class="mb-4">
            <v-col cols="2">
              <label class="font-weight-black">
                País de Origem <span class="field_required"> * </span>
              </label>
              <v-select
                v-model="form.location"
                :items="countryList"
                item-value="id"
                item-text="text"
                outlined
                dense
                required
                placeholder="Brasil"
              ></v-select>
            </v-col>

            <v-col cols="4">
              <label class="font-weight-black">
                CNPJ <span class="field_required"> * </span>
              </label>
              <v-text-field
                v-model="form.document"
                outlined
                dense
                :rules="cnpjRules"
                required
                v-mask="'##.###.###/####-##'"
                placeholder="CNPJ"
                @input="checkDocument"
                :error="!!cnpjErrorMessage"
                :error-messages="cnpjErrorMessage"
              >
                <template v-slot:append>
                  <v-progress-circular
                    v-if="loadingCNPJ"
                    class="ml-2"
                    color="primary"
                    size="20"
                    width="2"
                    indeterminate
                  ></v-progress-circular>
                  <v-icon
                    color="success"
                    v-if="!loadingCNPJ && statusCNPJ === 'ATIVA' && !cnpjErrorMessage"
                  >
                    mdi-check
                  </v-icon>
                  <v-icon
                    color="error"
                    v-if="!loadingCNPJ && (cnpjErrorMessage || statusCNPJ === 'BAIXADA')"
                  >
                    mdi-close
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="2">
              <label class="font-weight-black">
                Situação do CNPJ:
              </label>
              <div
                class="box_document"
                :class="{
                  'box_document-inactive': statusCNPJ === 'INAPTA' || statusCNPJ === 'BAIXADA',
                  'box_document-active': statusCNPJ === 'ATIVA'
                }"
              >
                <p class="ma-0 pa-2">{{ statusCNPJ || '-' }}</p>
              </div>
            </v-col>

            <v-col cols="4">
              <label class="font-weight-black">
                Razão Social <span class="field_required"> * </span>
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.name"
                outlined
                dense
                :rules="textRules"
                required
                placeholder="Razão Social"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mb-4">
            <v-col cols="4">
              <label class="font-weight-black">
                Nome Fantasia <span class="field_required"> * </span>
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.tradingName"
                outlined
                dense
                :rules="textRules"
                required
                placeholder="Nome Fantasia"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <label class="font-weight-black">
                Nome de exibição <span class="field_required"> * </span>
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.displayName"
                outlined
                :rules="textRules"
                required
                dense
                placeholder="Nome de exibição"
                append-icon="mdi-content-copy"
                @click:append="copyTxtTradingName('display')"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <label class="font-weight-black">
                Inscrição Estadual
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.ie"
                outlined
                dense
                placeholder="Inscrição Estadual"
              ></v-text-field>
            </v-col>
          </v-row>

          <p class="text-left mb-1 font-weight-bold grey--text lighten-2">
            ENDEREÇO
          </p>
          <v-divider class="mb-4"></v-divider>

          <v-row class="mb-4">
            <v-col cols="4">
              <label class="font-weight-black">
                Identificação <span class="field_required"> * </span>
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.address.label"
                outlined
                dense
                :rules="textRules"
                required
                placeholder="Identificação"
                append-icon="mdi-content-copy"
                @click:append="copyTxtTradingName('label')"
              ></v-text-field>
            </v-col>

            <v-col cols="2">
              <label class="font-weight-black">
                CEP <span class="field_required"> * </span>
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.address.zipCode"
                v-mask="'#####-###'"
                outlined
                dense
                :rules="textRules"
                required
                placeholder="CEP"
              ></v-text-field>
            </v-col>

            <v-col cols="6"></v-col>

            <v-col cols="4">
              <label class="font-weight-black">
                Endereço <span class="field_required"> * </span>
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.address.street"
                outlined
                dense
                :rules="textRules"
                required
                placeholder="Endereço"
              ></v-text-field>
            </v-col>

            <v-col cols="1">
              <label class="font-weight-black">
                Número <span class="field_required"> * </span>
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.address.number"
                outlined
                v-mask="'########'"
                dense
                :rules="textRules"
                required
                placeholder="Número"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <label class="font-weight-black">
                Complemento
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.address.complement"
                outlined
                dense
                placeholder="Complemento"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <label class="font-weight-black">
                Bairro <span class="field_required"> * </span>
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.address.district"
                outlined
                dense
                :rules="textRules"
                required
                placeholder="Bairro"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <label class="font-weight-black">
                Cidade <span class="field_required"> * </span>
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.address.city"
                outlined
                dense
                :rules="textRules"
                required
                placeholder="Cidade"
              ></v-text-field>
            </v-col>

            <v-col cols="2">
              <label class="font-weight-black">
                Estado <span class="field_required"> * </span>
              </label>
              <v-select
                :disabled="isFormDisabled"
                v-model="form.address.state"
                :items="stateList"
                item-value="id"
                item-text="text"
                outlined
                dense
                required
                placeholder="UF"
              ></v-select>
            </v-col>
          </v-row>

          <p class="text-left mb-1 font-weight-bold grey--text lighten-2">
            DADOS DE RECEBIMENTO
          </p>
          <v-divider class="mb-4"></v-divider>

          <v-row class="mb-4">
            <v-col cols="4">
              <label class="font-weight-black">
                Cód. do Banco
              </label>
              <v-autocomplete
                :disabled="isFormDisabled"
                v-model="form.bankAccount.bankCode"
                :items="banks"
                item-text="nameAndBankCode"
                item-value="bankId"
                outlined
                dense
                placeholder="Cód. do Banco"
              ></v-autocomplete>
            </v-col>

            <v-col cols="1">
              <label class="font-weight-black">Agência</label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.bankAccount.agency"
                outlined
                dense
                v-mask="'######'"
                placeholder="Agência"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <label class="font-weight-black">Conta</label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.bankAccount.account"
                outlined
                dense
                placeholder="Conta"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <label class="font-weight-black">Chave PIX</label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.bankAccount.pix"
                outlined
                dense
                placeholder="Chave PIX"
              ></v-text-field>
            </v-col>

            <v-col cols="2">
              <label class="font-weight-black">
                Tipo de Conta
              </label>
              <v-select
                :disabled="isFormDisabled"
                v-model="form.bankAccount.typeAccount"
                :items="typeAccountList"
                item-value="id"
                item-text="text"
                outlined
                dense
                placeholder="Tipo de Conta"
              ></v-select>
            </v-col>

            <v-col cols="3">
              <label class="font-weight-black">
                CNPJ do Titular
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.bankAccount.documentNumber"
                v-mask="'##.###.###/####-##'"
                outlined
                dense
                placeholder="CNPJ do Titular"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <label class="font-weight-black">
                Nome do Titular
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.bankAccount.ownerName"
                outlined
                dense
                placeholder="Nome do Titular"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <label class="font-weight-black">
                Telefone
              </label>
              <v-text-field
                :disabled="isFormDisabled"
                v-model="form.bankAccount.cellphone"
                outlined
                v-mask="'(##) #####-####'"
                dense
                placeholder="Telefone"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- SEÇÃO DE USUÁRIOS -->
          <p class="text-left mb-1 font-weight-bold grey--text lighten-2 mt-6">
            USUÁRIOS COM ACESSO A ESTE PERFIL
          </p>
          <v-divider class="mb-4"></v-divider>

          <v-row class="mb-5 v-text-field-styled">
            <v-col cols="5">
              <v-text-field 
                v-model="searchUserTxt" 
                hide-details 
                @input="handleSearchUserTxt" 
                append-icon="mdi-magnify"
                outlined 
                dense 
                placeholder="Adicione 1 ou mais usuários..." 
                class="v-input-user-createProfile"
              >
                <template v-slot:append>
                  <v-progress-circular 
                    v-if="loadingUsers" 
                    class="ml-2" 
                    color="grey" 
                    size="20" 
                    width="2"
                    indeterminate
                  ></v-progress-circular>
                </template>
              </v-text-field>

              <!-- Tabela de usuários disponíveis -->
              <v-card outlined>
                <v-data-table
                  :headers="availableUsersHeaders"
                  :items="filteredAvailableUsers"
                  :items-per-page="-1"
                  class="elevation-0"
                  hide-default-footer
                  :no-data-text="'Nenhum usuário encontrado'"
                  :loading="loadingUsers"
                  loading-text="Carregando usuários..."
                  dense
                  :height="300"
                  fixed-header
                >
                  <template v-slot:[`item.userName`]="{ item }">
                    <span style="font-size: 13px" class="font-weight-bold">{{ item.userName }}</span>
                  </template>
                  
                  <template v-slot:[`item.typeDc`]="{ item }">
                    <span style="font-size: 13px">{{ getAccessTypeText(item.profileStatusId) }}</span>
                  </template>
                  
                  <template v-slot:[`item.userEmail`]="{ item }">
                    <span style="font-size: 13px" class="font-weight-bold">{{ item.userEmail }}</span>
                  </template>
                  
                  <template v-slot:item="{ item }">
                    <tr @click="addToSelectedUsers(item)" style="cursor: pointer;" class="user-row">
                      <td class="text-start">
                        <span style="font-size: 13px" class="font-weight-bold">{{ item.userName }}</span>
                      </td>
                      <td class="text-start">
                        <span style="font-size: 13px">{{ getAccessTypeText(item.profileStatusId) }}</span>
                      </td>
                      <td class="text-start">
                        <span style="font-size: 13px" class="font-weight-bold">{{ item.userEmail }}</span>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>

            <v-col cols="7">
              <div class="d-flex justify-space-between align-center mb-4">
                <span class="font-weight-bold">Usuários associados: {{ allUsersSelected.length }}</span>
                <v-btn
                  x-small
                  color="error"
                  outlined
                  @click="removeAllSelectedUsers()"
                >
                  <v-icon small left>mdi-delete</v-icon>
                  Limpar tudo
                </v-btn>
              </div>

              <!-- Tabela de usuários selecionados -->
              <v-card outlined>
                <v-data-table
                  :headers="selectedUsersHeaders"
                  :items="allUsersSelected"
                  :items-per-page="-1"
                  class="elevation-0"
                  hide-default-footer
                  :no-data-text="'Nenhum usuário selecionado'"
                  dense
                  :height="300"
                  fixed-header
                >
                  <template v-slot:[`item.userName`]="{ item }">
                    <span style="font-size: 15px">{{ item.userName }}</span>
                  </template>
                  
                  <template v-slot:[`item.typeId`]="{ item }">
                    <v-select 
                      :items="accessTypeIdItems" 
                      v-model="item.typeId" 
                      dense
                      item-value="id" 
                      item-text="name" 
                      hide-details
                      :disabled="item.adminSelected"
                      style="min-width: 120px;"
                    ></v-select>
                  </template>
                  
                  <template v-slot:[`item.userEmail`]="{ item }">
                    <span style="font-size: 15px; word-break: break-word;">{{ item.userEmail }}</span>
                  </template>
                  
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom v-if="isLoggedUser(item)">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon 
                          color="grey"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-account-check
                        </v-icon>
                      </template>
                      <span>Sua associação é obrigatória</span>
                    </v-tooltip>
                    <v-btn
                      v-else
                      icon
                      x-small
                      color="error"
                      @click="removeSelectedUser(item)"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>

        </v-form>

        <div class="d-flex justify-end pa-4">
          <v-btn color="error" @click="showCancelDialog = true" class="mr-3 white--text force-white-text">
            Cancelar
          </v-btn>
          <v-btn
            color="green"
            @click="submitProfileForm"
            :loading="loadingSubmitProfile"
            :disabled="!valid || isFormDisabled"
            class="white--text "
          >
            Criar Veículo
          </v-btn>
        </div>
      </v-card>
    </v-card>

    <!-- Dialog de Criação de Usuário -->
    <v-dialog v-model="statusCreateUserDialog" max-width="800">
      <v-card class="pa-5 px-8">
        <div class="d-flex justify-space-between align-center mb-5">
          <p class="font-weight-bold ma-0 text-h6">Criação de usuário:</p>
          <v-btn icon @click="statusCreateUserDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-row>
          <v-col class="py-0" cols="6">
            <v-text-field 
              required 
              hide-details 
              class="my-2" 
              label="Nome *" 
              v-model="formUser.name" 
              outlined
              dense 
              :rules="textRules" 
              placeholder="Nome"
            ></v-text-field>
          </v-col>

          <v-col class="py-0" cols="6">
            <v-text-field 
              required 
              :error-messages="emailErrors" 
              hide-details 
              class="mt-2" 
              label="E-mail *"
              v-model="formUser.email" 
              @input="handleEmailInput" 
              outlined 
              dense 
              :rules="textRules" 
              placeholder="E-mail"
            >
              <template v-slot:append>
                <v-progress-circular 
                  v-if="loadingEmail" 
                  class="ml-2" 
                  color="primary" 
                  size="20" 
                  width="2"
                  indeterminate
                ></v-progress-circular>
                <v-icon color="red" v-if="emailErrors && emailErrors.length > 0">
                  mdi-close
                </v-icon>
                <v-icon color="success" v-if="!emailErrors || (emailErrors.length === 0 && isEmailAvailable)">
                  mdi-check
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col class="py-0" cols="6">
            <v-text-field 
              hide-details 
              class="my-2" 
              label="Cargo (Opcional)" 
              v-model="formUser.job_description"
              outlined 
              dense 
              placeholder="Executivo de vendas"
            ></v-text-field>
          </v-col>

          <v-col class="py-0" cols="6">
            <v-select 
              required 
              hide-details 
              class="my-2" 
              label="Setor *" 
              :items="accessTypeIdItems" 
              placeholder="Setor"
              v-model="formUser.accessTypeId" 
              outlined 
              item-value="id" 
              item-text="name" 
              dense
              :menu-props="{ width: '20px' }"
            ></v-select>
          </v-col>
        </v-row>

        <v-row class="align-center" v-for="(phone, index) in formUser.phones" :key="index">
          <v-col class="py-0" cols="3">
            <v-select 
              required 
              :items="phoneTypes" 
              item-value="id" 
              item-text="name" 
              placeholder="Tipo *"
              v-model="phone.type" 
              outlined 
              dense 
              :menu-props="{ width: '20px' }" 
              hide-details
            ></v-select>
          </v-col>

          <v-col class="py-0" cols="3">
            <v-autocomplete 
              required 
              item-text="code" 
              item-value="code" 
              :items="allDDIs" 
              placeholder="DDI *"
              v-model="phone.prefixo" 
              outlined 
              dense 
              :menu-props="{ width: '20px' }" 
              hide-details
            ></v-autocomplete>
          </v-col>

          <v-col class="py-0" cols="5">
            <v-text-field 
              required 
              hide-details 
              class="my-2" 
              label="Telefone *" 
              v-model="phone.number"
              v-mask="['(##) ####-####', '(##) #####-####']" 
              outlined 
              dense 
              :rules="textRules"
              placeholder="Telefone"
            ></v-text-field>
          </v-col>

          <v-col class="py-0 mb-2" cols="1">
            <v-icon @click="removePhone(index)">mdi-trash-can</v-icon>
          </v-col>
        </v-row>

        <v-btn text color="primary" class="my-2" @click="addPhone">
          + Adicionar Telefone
        </v-btn>

        <v-text-field 
          required 
          hide-details 
          class="my-2" 
          label="Vínculo de atendimento *" 
          v-model="formUser.info"
          outlined 
          dense 
          :rules="textRules"
          placeholder="Executivo para o setor financeiro"
        ></v-text-field>

        <v-text-field 
          hide-details 
          v-if="!isAutomaticPassword" 
          class="mt-2" 
          label="Senha" 
          v-model="formUser.password"
          outlined 
          dense 
          :rules="textRules" 
          required 
          placeholder="Senha"
        ></v-text-field>

        <v-checkbox 
          @input="changeAutomaticPassword" 
          v-model="isAutomaticPassword"
          label="Incluir senha automática"
        ></v-checkbox>

        <v-btn @click="submitFormUser" style="color: white" color="green" class="white--text font-weight-bold">
          Criar usuário
          <v-progress-circular 
            class="ml-2" 
            v-if="loadingCreateUser" 
            color="white" 
            size="20"
            indeterminate
          ></v-progress-circular>
        </v-btn>
      </v-card>

      <v-snackbar v-model="toastCreateUserBox" :timeout="4000" color="primary" top>
        {{ textToastCreateUserBox }}
      </v-snackbar>
    </v-dialog>

    <!-- Dialog de Confirmação de Cancelamento -->
    <v-dialog v-model="showCancelDialog" max-width="500">
      <v-card>
        <v-card-text class="pt-4">
          <p class="mb-3">
            Tem certeza de que deseja cancelar a criação do perfil?
          </p>
          <p class="mb-0 font-weight-bold red--text">
            Todos os dados inseridos serão perdidos e não poderão ser recuperados.
          </p>
        </v-card-text>
        
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn 
            color="green" 
            text 
            @click="showCancelDialog = false"
          >
            Continuar editando
          </v-btn>
          <v-btn 
            color="error" 
            dark
            @click="confirmCancel"
          >
            <v-icon left>mdi-close</v-icon>
            Sim, cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbars -->
    <v-snackbar
      v-model="toastSubmitProfileSuccess"
      :timeout="4000"
      color="success"
      top
    >
      {{ textToastProfileSuccess }}
    </v-snackbar>

    <v-snackbar
      v-model="toastSubmitProfileError"
      :timeout="4000"
      color="error"
      top
    >
      {{ textToastProfileError }}
    </v-snackbar>


  </div>
</template>

<script>
import ImageUploadWithCrop from '@/components/globalComponents/ImageUploadWithCrop.vue';
import { getAuth } from '@/services/authService'

export default {
  name: 'CreateProfile',

  components: {
    ImageUploadWithCrop
  },

  data() {
    return {
      valid: false,
      isFormDisabled: true,
      loadingCNPJ: false,
      loadingSubmitProfile: false,
      statusCNPJ: null,
      banks: [],

      toastSubmitProfileSuccess: false,
      textToastProfileSuccess: "Veículo criado com sucesso!",
      toastSubmitProfileError: false,
      textToastProfileError: "Erro ao criar veículo!",
      
      
      toastCNPJError: false,
      textToastCNPJError: "",
      cnpjErrorMessage: "",
      
      
      showCancelDialog: false,

      
      statusCreateUserDialog: false,
      loadingEmail: false,
      isEmailAvailable: null,
      isEmailValid: null,
      isAutomaticPassword: true,
      loadingCreateUser: false,
      loadingUsers: false,
      toastCreateUserBox: false,
      textToastCreateUserBox: "Termine a criação de usuário para avançar na criação do veículo!",
      searchUserTxt: "",
      allUsers: [],
      allUsersSelected: [],

      
      availableUsersHeaders: [
        {
          text: "Nome",
          value: "userName",
          align: "start",
          sortable: false,
          width: "35%"
        },
        {
          text: "Setor",
          value: "typeDc",
          align: "start",
          sortable: false,
          width: "30%"
        },
        {
          text: "E-mail",
          value: "userEmail",
          align: "start",
          sortable: false,
          width: "35%"
        },
      ],

      selectedUsersHeaders: [
        {
          text: "Nome",
          value: "userName",
          align: "start",
          sortable: false,
          width: "25%"
        },
        {
          text: "Setor",
          value: "typeId",
          align: "start",
          sortable: false,
          width: "25%"
        },
        {
          text: "E-mail",
          value: "userEmail",
          align: "start",
          sortable: false,
          width: "40%"
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
          width: "10%"
        }
      ],

      countryList: [
        {
          id: "BRA",
          text: "Brasil",
        },
      ],

      stateList: [
        { id: "AC", text: "AC" },
        { id: "AL", text: "AL" },
        { id: "AP", text: "AP" },
        { id: "AM", text: "AM" },
        { id: "BA", text: "BA" },
        { id: "CE", text: "CE" },
        { id: "DF", text: "DF" },
        { id: "ES", text: "ES" },
        { id: "GO", text: "GO" },
        { id: "MA", text: "MA" },
        { id: "MT", text: "MT" },
        { id: "MS", text: "MS" },
        { id: "MG", text: "MG" },
        { id: "PA", text: "PA" },
        { id: "PB", text: "PB" },
        { id: "PR", text: "PR" },
        { id: "PE", text: "PE" },
        { id: "PI", text: "PI" },
        { id: "RJ", text: "RJ" },
        { id: "RN", text: "RN" },
        { id: "RS", text: "RS" },
        { id: "RO", text: "RO" },
        { id: "RR", text: "RR" },
        { id: "SC", text: "SC" },
        { id: "SP", text: "SP" },
        { id: "SE", text: "SE" },
        { id: "TO", text: "TO" },
      ],

      typeAccountList: [
        {
          id: "1",
          text: "Júridica",
        },
      ],

      accessTypeIdItems: [
        { id: 1, name: "Administrador" },
        { id: 3, name: "Comercial" },
        { id: 4, name: "Marketing" },
        { id: 5, name: "Financeiro" },
        { id: 9, name: "Criativo" },
        { id: 10, name: "OPEC" },
      ],

      phoneTypes: [
        { id: 8, name: "Celular" },
        { id: 2, name: "Telefone Fixo" },
        { id: 9, name: "Whatsapp" },
      ],

      allDDIs: [
        { code: "+55", name: "Brasil" },
        { code: "+1", name: "Estados Unidos" },
        { code: "+54", name: "Argentina" },
      ],

      formUser: {
        name: "",
        email: "",
        password: "",
        phones: [{ type: "", prefixo: "", number: "" }],
        job_description: "",
        accessTypeId: null,
        info: "",
      },

      form: {
        location: "BRA",
        document: "",
        name: "",
        tradingName: "",
        displayName: "",
        ie: "",
        logoBase64: null,
        logoFile: null,
        logoFilename: null,
        address: {
          state: "",
          complement: "",
          city: "",
          country: "Brasil",
          zipCode: "",
          number: "",
          street: "",
          label: "",
          district: "",
        },
        bankAccount: {
          bankCode: null,
          agency: "",
          account: "",
          pix: "",
          typeAccount: "",
          cellphone: "",
          ownerName: "",
          documentNumber: "",
        },
      },

      textRules: [
        (v) => !!v || "Campo Obrigatório",
      ],
      
      cnpjRules: [
        (v) => !!v || "Campo Obrigatório",
      ],
    };
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (this.isEmailAvailable === false) {
        errors.push("E-mail já cadastrado");
      }
      if (this.isEmailValid === false) {
        errors.push("E-mail inválido");
      }
      return errors;
    },

    formattedUsers() {
      return this.allUsersSelected.map(user => ({
        id: parseInt(user.userId),
        profileAccessTypeId: parseInt(user.typeId)
      }));
    },

    auth() {
      return getAuth();
    },

    filteredAvailableUsers() {
      
      return this.allUsers.filter(user => {
        return !this.allUsersSelected.some(selectedUser => selectedUser.userId == user.userId);
      });
    },
  },

  created() {
    this.getAllBanks();
    this.getAllUsers();
    this.addLoggedUserToSelected();
  },

  methods: {
    goBack() {
      this.resetForm();
      this.$router.push('/app/management');
    },

    resetForm() {
      this.form = {
        location: "BRA",
        document: "",
        name: "",
        tradingName: "",
        displayName: "",
        ie: "",
        logoBase64: null,
        logoFile: null,
        logoFilename: null,
        address: {
          state: "",
          complement: "",
          city: "",
          country: "Brasil",
          zipCode: "",
          number: "",
          street: "",
          label: "",
          district: "",
        },
        bankAccount: {
          bankCode: null,
          agency: "",
          account: "",
          pix: "",
          typeAccount: "",
          cellphone: "",
          ownerName: "",
          documentNumber: "",
        },
      };
      this.statusCNPJ = null;
      this.isFormDisabled = true;
      this.valid = false;
    },

    addLoggedUserToSelected() {
      const auth = getAuth();
      const loggedUser = auth?.user;
      
      if (loggedUser) {
        
        const userForSelection = {
          userId: loggedUser.uid.toString(),
          userName: loggedUser.name,
          userEmail: loggedUser.email,
          typeId: parseInt(loggedUser.profileStatusId) || 1 
        };

        
        const isAlreadySelected = this.allUsersSelected.some(
          user => user.userId === userForSelection.userId
        );

        if (!isAlreadySelected) {
          this.allUsersSelected.push(userForSelection);
        }
      }
    },

    async checkDocument() {
      try {
        const cnpjFormatted = this.form.document.replace(/[^\d]/g, "");

        if (cnpjFormatted.length === 14) {
          this.loadingCNPJ = true;
          const response = await this.$axios.post(`assets/checker/documentId`, {
            input: "documentId",
            value: cnpjFormatted,
          });

          if (response.data && response.data.data) {
            const data = response.data.data;
            
            
            if (data.available === false) {
              
              const userHasAccess = this.checkUserHasAccessToCNPJ(cnpjFormatted);
              
              if (userHasAccess) {
                this.cnpjErrorMessage = "Este CNPJ já está cadastrado e você já possui acesso.";
              } else {
                this.cnpjErrorMessage = "Este CNPJ já está cadastrado e você não possui acesso. Se precisar de ajuda, entre em contato pelo parceiros@themediatrade.com";
              }
              
              this.isFormDisabled = true;
              this.statusCNPJ = null;
              return;
            }
            
            
            if (data.companyData) {
              this.cnpjErrorMessage = ""; 
              this.statusCNPJ = data.companyData.situacao;
              this.bindProfileData(data);

              if (data.available === true && this.statusCNPJ === "ATIVA") {
                this.isFormDisabled = false;
              } else {
                this.isFormDisabled = true;
              }
            }
          }
        } else {
          this.cnpjErrorMessage = ""; 
          this.isFormDisabled = true;
          this.statusCNPJ = null;
        }
      } catch (error) {
        console.error('Erro ao verificar CNPJ:', error);
        this.cnpjErrorMessage = "Erro ao verificar CNPJ. Tente novamente.";
        this.isFormDisabled = true;
        this.statusCNPJ = null;
      } finally {
        this.loadingCNPJ = false;
      }
    },

    checkUserHasAccessToCNPJ(cnpj) {
      if (!this.auth || !this.auth.profiles) {
        return false;
      }
      
      
      return Object.values(this.auth.profiles).some(profile => {
        const profileCNPJ = profile.document ? profile.document.replace(/[^\d]/g, "") : "";
        return profileCNPJ === cnpj;
      });
    },

    bindProfileData(data) {
      this.form.name = data.companyData?.nome || this.form.name;
      this.form.address.number = data.companyData?.numero || this.form.address.number;
      this.form.address.complement = data.companyData?.complemento || this.form.address.complement;
      this.form.address.district = data.companyData?.bairro || this.form.address.district;
      this.form.address.zipCode = data.companyData?.cep || this.form.address.zipCode;
      this.form.address.street = data.companyData?.logradouro || this.form.address.street;
      this.form.address.state = data.companyData?.uf || this.form.address.state;
      this.form.tradingName = data.companyData?.fantasia || this.form.tradingName;
      this.form.address.label = data.companyData?.fantasia || this.form.address.label;
      this.form.address.city = data.companyData?.municipio || this.form.address.city;
      this.form.bankAccount.documentNumber = this.form.document;
    },

    confirmCancel() {
      this.showCancelDialog = false;
      this.resetForm();
      this.$router.push('/app/management/profiles');
    },

    async getAllBanks() {
      try {
        const response = await this.$axios.get(`assets/banks`);
        if (response.data && response.data.data) {
          const allBanks = response.data.data;
          const allBanksFormatted = allBanks.map((bank) => ({
            id: bank.bankId,
            bankId: bank.febrabanCode,
            name: bank.name,
            nameAndBankCode: `${bank.febrabanCode} - ${bank.name}`,
          }));

          allBanksFormatted.sort((a, b) => a.bankId - b.bankId);
          this.banks = allBanksFormatted;
        }
      } catch (error) {
        console.error('Erro ao carregar bancos:', error);
      }
    },

    copyTxtTradingName(field) {
      switch (field) {
        case "display":
          this.form.displayName = this.form.tradingName;
          break;
        case "label":
          this.form.address.label = this.form.tradingName;
          break;
        default:
          break;
      }
    },

    isLoggedUser(user) {
      const auth = getAuth();
      const loggedUserId = auth?.user?.uid?.toString();
      return user.userId === loggedUserId;
    },

    getAccessTypeText(typeId) {
      const accessType = this.accessTypeIdItems.find(item => item.id == typeId);
      return accessType ? accessType.name : '-';
    },

    
    async getAllUsers(searchText = "") {
      try {
        this.loadingUsers = true;
        const profilesResponse = await this.$axios.get(`profiles`);
        if (!profilesResponse.data || !profilesResponse.data.data) {
          console.error('Nenhum perfil encontrado');
          return;
        }
        const profilesData = profilesResponse.data.data;
        const profileIds = Object.keys(profilesData)
          .map(key => profilesData[key].profileId)
          .filter(id => id); 

        if (profileIds.length === 0) {
          console.error('Nenhum profileId encontrado');
          return;
        }
        const response = await this.$axios.post(`profiles/admin/assoc/profiles/multiple`, { profileIds });

        if (response.data && response.data.data) {
          this.allUsers = response.data.data;
        }
      } catch (error) {
        console.error('Erro ao carregar usuários:', error);
      } finally {
        this.loadingUsers = false;
      }
    },

    handleSearchUserTxt() {
      this.debouncedGetSpecificUser();
    },

    debouncedGetSpecificUser() {
      setTimeout(() => {
        this.getAllUsers(this.searchUserTxt);
      }, 500);
    },

    addToSelectedUsers(user) {
      const isUserAlreadySelected = this.allUsersSelected.some(
        (selectedUser) => selectedUser.userId == user.userId
      );

      if (!isUserAlreadySelected) {
        

        console.log('user', user)
        const userWithSetor = {
          ...user,
          typeId: parseInt(user.profileStatusId) 
        };
        this.allUsersSelected.push(userWithSetor);
      }
    },

    removeSelectedUser(user) {
      const auth = getAuth();
      const loggedUserId = auth?.user?.uid?.toString();
      
      if (user.userId === loggedUserId) {
        console.log('Não é possível remover o usuário logado');
        return;
      }

      const userIndexToRemove = this.allUsersSelected.findIndex(
        (userIndex) => userIndex.userEmail === user.userEmail
      );
      if (userIndexToRemove !== -1) {
        this.allUsersSelected.splice(userIndexToRemove, 1);
      }
    },

    removeAllSelectedUsers() {
      const auth = getAuth();
      const loggedUserId = auth?.user?.uid?.toString();
      
      
      this.allUsersSelected = this.allUsersSelected.filter(
        user => user.userId === loggedUserId
      );
    },

    setStatusCreateUserDialog() {
      this.statusCreateUserDialog = !this.statusCreateUserDialog;
    },

    handleEmailInput(event) {
      this.formUser.email = event;
      this.debouncedCheckEmail();
    },

    debouncedCheckEmail() {
      setTimeout(() => {
        this.checkEmail();
      }, 500);
    },

    async checkEmail() {
      try {
        this.loadingEmail = true;
        this.isEmailAvailable = null;
        this.isEmailValid = null;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.formUser.email)) {
          this.loadingEmail = false;
          this.isEmailValid = false;
          return;
        }

        const response = await this.$axios.post(`assets/checker/email`, {
          input: "email",
          value: this.formUser.email,
        });

        this.isEmailAvailable = response.data.data.available;
        this.loadingEmail = false;
      } catch (error) {
        console.error('Erro ao verificar email:', error);
        this.loadingEmail = false;
      }
    },

    changeAutomaticPassword() {
      this.isAutomaticPassword = !this.isAutomaticPassword;
    },

    addPhone() {
      this.formUser.phones.push({ type: "", prefixo: "", number: "" });
    },

    removePhone(index) {
      if (index === 0) {
        this.formUser.phones[0] = { type: "", prefixo: "", number: "" };
      } else {
        this.formUser.phones.splice(index, 1);
      }
    },

    cleanFormUserValues() {
      this.formUser = {
        name: "",
        email: "",
        password: "",
        phones: [{ type: "", prefixo: "", number: "" }],
        job_description: "",
        accessTypeId: null,
        info: "",
      };
    },

    async submitFormUser() {
      this.loadingCreateUser = true;

      try {        
        const phonesFormatted = this.formUser.phones
          .filter(phone => phone.number && phone.type && phone.prefixo)
          .map((phone) => {
            const patterToRemoveNumberDetails = /\((\d{2})\)\s*(\d{4,5})-(\d{4})/;
            const numberFormatted = phone.number.match(patterToRemoveNumberDetails);

            return {
              type: phone.type,
              ddd: numberFormatted ? numberFormatted[1] : "",
              ddi: phone.prefixo.slice(1),
              number: numberFormatted ? numberFormatted[2] + numberFormatted[3] : phone.number,
            };
          });

        let formattedForm = {
          name: this.formUser.name,
          email: this.formUser.email,
          phones: phonesFormatted,
          info: this.formUser.info,
          accessTypeId: this.formUser.accessTypeId,
          jobDescription: this.formUser.job_description,
          attachSAMT: true
        };

        if (!this.isAutomaticPassword) {
          formattedForm.password = this.formUser.password;
        }

        const response = await this.$axios.post(`publisherportal/register`, formattedForm);

        const userCreated = response.data.data.userData;
        userCreated.phones = userCreated.phones?.map((phone) => {
          return `+${phone.ddi} (${phone.ddd}) ${phone.number}`;
        }) || [];

        this.allUsersSelected.push(userCreated);
        this.getAllUsers();
        
        this.loadingCreateUser = false;
        this.statusCreateUserDialog = false;
        this.cleanFormUserValues();

      } catch (error) {
        console.error('Erro ao criar usuário:', error);
        this.loadingCreateUser = false;
      }
    },

    handleLogoSelected(data) {
      this.form.logoBase64 = data.base64;
      this.form.logoFile = data.file;
      this.form.logoFilename = data.file.name;
    },

    handleLogoRemoved() {
      this.form.logoBase64 = null;
      this.form.logoFile = null;
      this.form.logoFilename = null;
    },

    async submitProfileForm() {
      this.loadingSubmitProfile = true;

      try {
        const dataProfile = {
          mv: true,
          name: this.form.name,
          displayName: this.form.displayName,
          tradingName: this.form.tradingName,
          document: this.form.document,
          ie: this.form.ie,
          statusId: 1,
          profileTypeId: 2,
          location: this.form.location,
          users: this.formattedUsers,
          address: {
            country: this.form.address.country,
            state: this.form.address.state,
            city: this.form.address.city,
            street: this.form.address.street,
            district: this.form.address.district,
            number: this.form.address.number,
            complement: this.form.address.complement,
            zipCode: this.form.address.zipCode,
            label: this.form.address.label,
          },
          bankAccount: {
            bankId: this.form.bankAccount.bankCode,
            type: 2,
            agencyNumber: this.form.bankAccount.agency,
            accountNumber: this.form.bankAccount.account,
            pix: this.form.bankAccount.pix,
            ownerName: this.form.bankAccount.ownerName,
            documentNumber: this.form.bankAccount.documentNumber,
          },
        };

        if (this.form.logoBase64 && this.form.logoFilename) {
          dataProfile.file = {
            filename: this.form.logoFilename,
            base64: this.form.logoBase64
          };
        }

        await this.$axios.post(`profiles/admin/register`, dataProfile);

        this.toastSubmitProfileSuccess = true;
        this.textToastProfileSuccess = "Veículo criado com sucesso!";
        
        setTimeout(() => {
          this.$router.push('/app/management/profiles');
        }, 2000);

      } catch (error) {
        console.error('Erro ao criar profile:', error);
        this.toastSubmitProfileError = true;
        
        if (error.response && error.response.data && error.response.data.errors) {
          const submitErrors = error.response.data.errors[0];
          this.textToastProfileError = `Erro: ${Object.values(submitErrors)[0]}`;
        } else {
          this.textToastProfileError = "Erro ao criar veículo. Tente novamente!";
        }
      } finally {
        this.loadingSubmitProfile = false;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: 'Roboto', sans-serif !important;
}

.theme--light.v-sheet {
   border-color: rgb(168, 168, 168) !important; 
}

.field_required {
  color: red;
}

.box_document {
  border: 1px solid #c0c0c0;
  border-radius: 4px;
  height: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box_document-active {
  border: 1px solid gray;
  background-color: rgb(23, 232, 0);
  color: white;
}

.box_document-inactive {
  border: 1px solid gray;
  background-color: rgb(232, 0, 0);
  color: white;
}

.create-profile-container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

/* Estilos para seção de usuários */
.container_user_createProfile {
  border: 1px solid #9e9e9e;
  border-top: unset;
  height: 303px;
  overflow-y: scroll;
}

.container_user_createProfile::-webkit-scrollbar {
  width: 12px;
}

.container_user_createProfile::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 15px;
}

.container_user_createProfile::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.btn-createNew-container {
  border: 1px solid #9e9e9e;
  border-top: unset;
}

.addedUsers-container {
  border: 1px solid #9e9e9e;
  height: 32px;
}

.legend-container {
  border: 1px solid #9e9e9e;
  border-top: unset;
  height: 32px;
}

.container_user_createProfile-heightCustom {
  height: 280px;
}

.btn-veicle {
  width: 100%;
  transition: 0.3s;
  border: none;
  background: none;
  padding: 8px;
}

.btn-veicle:hover {
  background-color: #eaeaea;
}

.v-input--selection-controls {
  margin: 0 !important;
  padding: 0 !important;
}

.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: unset;
}

.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: unset;
}

* {
  font-family: 'Roboto', sans-serif !important;
}

.user-row:hover {
  background-color: #f5f5f5 !important;
  transition: background-color 0.2s ease;
}

.user-row:hover .v-icon {
  color: #1976d2 !important;
  transform: scale(1.1);
  transition: all 0.2s ease;
}

.force-white-text {
  color: #fff !important;
}
</style>